import { MantineSpacing, Title, TitleOrder } from '@mantine/core'

export const SectionTitle = ({
  children,
  order = 2,
  mb = 'md',
  style,
}: {
  children: React.ReactNode
  order: TitleOrder
  /** Bottom margin; pass 0 when the title sits in a row with other elements. `style.margin` does not override it. */
  mb?: MantineSpacing | 0
  style?: React.CSSProperties
}) => {
  return (
    <Title order={order} size="h2" mb={mb} c="light-dark(#868e96, #c9c9c9)" style={style}>
      {children}
    </Title>
  )
}
